import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-2e8c7cd8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "银行账号", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "通知存款", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资金清分", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资金统计", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "系统设置", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "logo"
}), /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "栖霞区住宅物业保修金管理系统")], -1));
const _hoisted_8 = {
  class: "header-right"
};
const _hoisted_9 = {
  class: "el-dropdown-link"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Postcard = _resolveComponent("Postcard");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_Bell = _resolveComponent("Bell");
  const _component_Connection = _resolveComponent("Connection");
  const _component_EditPen = _resolveComponent("EditPen");
  const _component_Setting = _resolveComponent("Setting");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_badge = _resolveComponent("el-badge");
  const _component_Avatar = _resolveComponent("Avatar");
  const _component_arrow_down = _resolveComponent("arrow-down");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_aside, {
      class: "common-aside"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu, {
        "default-active": _ctx.path,
        "background-color": "none",
        "text-color": "white",
        router: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
          index: "1"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Postcard)]),
            _: 1
          }), _hoisted_2]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: "/account/list"
            }, {
              default: _withCtx(() => [_createTextVNode("账号列表")]),
              _: 1
            }), _createVNode(_component_el_menu_item, {
              index: "/account/add"
            }, {
              default: _withCtx(() => [_createTextVNode("账户开户")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "2"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Bell)]),
            _: 1
          }), _hoisted_3]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: "/tzck/add"
            }, {
              default: _withCtx(() => [_createTextVNode("存款开立")]),
              _: 1
            }), _createVNode(_component_el_menu_item, {
              index: "/tzck/list"
            }, {
              default: _withCtx(() => [_createTextVNode("存款列表")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "3"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Connection)]),
            _: 1
          }), _hoisted_4]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: "/zjqf/list"
            }, {
              default: _withCtx(() => [_createTextVNode("待清分列表")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "4"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_EditPen)]),
            _: 1
          }), _hoisted_5]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: "/zjtj/record"
            }, {
              default: _withCtx(() => [_createTextVNode("手工录入")]),
              _: 1
            }), _createVNode(_component_el_menu_item, {
              index: "/zjtj/list"
            }, {
              default: _withCtx(() => [_createTextVNode("统计列表")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "99"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Setting)]),
            _: 1
          }), _hoisted_6]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item, {
              index: "/user"
            }, {
              default: _withCtx(() => [_createTextVNode("账号列表")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"])]),
      _: 1
    }), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_header, {
        class: "common-header"
      }, {
        default: _withCtx(() => [_hoisted_7, _createElementVNode("div", _hoisted_8, [$setup.msg_num > 0 ? (_openBlock(), _createBlock(_component_el_badge, {
          key: 0,
          value: $setup.msg_num,
          class: "bell",
          onClick: $setup.gotoQingfen
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: "large",
            color: "#409EFC"
          }, {
            default: _withCtx(() => [_createVNode(_component_Bell)]),
            _: 1
          })]),
          _: 1
        }, 8, ["value", "onClick"])) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          size: "large",
          class: "bell",
          color: "#409EFC"
        }, {
          default: _withCtx(() => [_createVNode(_component_Bell)]),
          _: 1
        })), _createVNode(_component_el_dropdown, {
          "hide-on-click": false,
          class: "username"
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              onClick: $setup.handleLogout
            }, {
              default: _withCtx(() => [_createTextVNode("退出")]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_icon, {
            class: "avatar"
          }, {
            default: _withCtx(() => [_createVNode(_component_Avatar)]),
            _: 1
          }), _createTextVNode(" " + _toDisplayString(_ctx.username), 1), _createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_arrow_down)]),
            _: 1
          })])]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_main, {
        class: "common-main"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component
          }) => [_createVNode(_Transition, null, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
            _: 2
          }, 1024)]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}